import React from 'react';

import {
  trackClick,
  Options as ClickTrackingOptions,
} from 'js/utils/trackClick';
import { Button } from 'js/design_system/Button';

import { TitleText, BodyText, BodyTextSmall } from './common';
import { ModalPage } from '../types';
import { BackButton } from '../components/BackButton';
import { VerticalSpacer } from '../components/VerticalSpacer';
import { CenteredDiv } from '../components/CenteredDiv';

type Props = {
  userEmail: string;
  show: boolean;
  setPage: React.Dispatch<React.SetStateAction<ModalPage>>;
  modalRef: React.RefObject<HTMLDialogElement>;
  clickTrackingContext?: Partial<ClickTrackingOptions>;
};

export const PasswordResetPage: React.FC<Props> = (props) => {
  const { userEmail, show, setPage, modalRef, clickTrackingContext } = props;
  return (
    <div style={{ display: show ? 'initial' : 'none' }}>
      <BackButton onClick={() => setPage('email-login')} />
      <TitleText>Password reset</TitleText>
      <BodyText>Check your email for your reset link.</BodyText>
      <VerticalSpacer height={40} />
      <BodyTextSmall>Your link was sent to {userEmail}</BodyTextSmall>
      <VerticalSpacer height={40} />
      <CenteredDiv>
        <Button
          size="lg"
          type="submit"
          disabled={!show}
          onClick={() => {
            trackClick({
              source: 'login_modal_password_reset_done_button',
              ...clickTrackingContext,
            });
            modalRef.current?.close();
          }}
        >
          Done
        </Button>
      </CenteredDiv>
    </div>
  );
};
